<template>
  <!--<nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav>-->
  <div class="bg dark" :class="bgTheme">
    <router-view/>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useBackground } from './composables/useBackground'

const { backgroundTheme } = useBackground()
const bgTheme = computed(() => `bg-${backgroundTheme.value}`)
</script>

<style lang="scss">
html, body {
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.bg {
  padding: 5vh 0;
  min-height: 90vh;
  color: #2c3e50;

  &.dark {
    color: #FFFFFF;
  }

  &.bg-start {
    background: #232526;
    background: -webkit-linear-gradient(150deg, #414345, #232526);
    background: linear-gradient(150deg, #414345, #232526);
  }

  &.bg-rest {
    background: #24C6DC;
    background: -webkit-linear-gradient(-150deg, #514A9D, #24C6DC);
    background: linear-gradient(-150deg, #514A9D, #24C6DC);
  }

  &.bg-work {
    background: #93291e;
    background: -webkit-linear-gradient(-150deg, #ed213a, #93291e);
    background: linear-gradient(-150deg, #ed213a, #93291e);
  }

  &.bg-final {
    background: #FF8008;
    background: -webkit-linear-gradient(-150deg, #FFC837, #FF8008);
    background: linear-gradient(-150deg, #FFC837, #FF8008);
  }
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

button {
  font-size: 1.5rem;
  border-radius: 2rem;
  border: none;
  border-collapse: unset;
  background-color: #F2F2F2;
  box-shadow: 0 0 4px #00000099;
  padding: .5rem 3rem;
}

/**
 * BG Gradients

// Midnight City - Home and Pause
background: #232526;  /
background: -webkit-linear-gradient(to left, #414345, #232526);
background: linear-gradient(to left, #414345, #232526);

// Facebook Messenger
background: #00c6ff;
background: -webkit-linear-gradient(to left, #0072ff, #00c6ff);
background: linear-gradient(to left, #0072ff, #00c6ff);

// Amethyst
background: #9D50BB;
background: -webkit-linear-gradient(to left, #6E48AA, #9D50BB);
background: linear-gradient(to left, #6E48AA, #9D50BB);

// Neon Life - greenisch
background: #B3FFAB;
background: -webkit-linear-gradient(to left, #12FFF7, #B3FFAB);
background: linear-gradient(to left, #12FFF7, #B3FFAB);

// dance to forget - reddish -> Active
background: #FF4E50;
background: -webkit-linear-gradient(to left, #F9D423, #FF4E50);
background: linear-gradient(to left, #F9D423, #FF4E50);

// Reef - bluisch - rest
background: #00d2ff;
background: -webkit-linear-gradient(to left, #3a7bd5, #00d2ff);
background: linear-gradient(to left, #3a7bd5, #00d2ff);

// Aqualishous - bluisch, finishd?
background: #50C9C3;
background: -webkit-linear-gradient(to left, #96DEDA, #50C9C3);
background: linear-gradient(to left, #96DEDA, #50C9C3);

// Mantle - bluisch like FB Mess
background: #24C6DC;
background: -webkit-linear-gradient(to left, #514A9D, #24C6DC);
background: linear-gradient(to left, #514A9D, #24C6DC);

// Sea Blizz - bluisch final
background: #1CD8D2;
background: -webkit-linear-gradient(to left, #93EDC7, #1CD8D2);
background: linear-gradient(to left, #93EDC7, #1CD8D2);

// Juicy Orange - Happy Finals!
background: #FF8008;
background: -webkit-linear-gradient(to left, #FFC837, #FF8008);
background: linear-gradient(to left, #FFC837, #FF8008);

 */
</style>
